'use client';

import { c as _c } from "react/compiler-runtime";
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Image } from '@/components/client';
interface CertificateCardProps {
  year: number | null;
  name: string;
}
export const CertificateCard = t0 => {
  const $ = _c(22);
  const {
    year,
    name
  } = t0;
  const [currentDate, setCurrentDate] = useState(_temp);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const interval = setInterval(() => {
        setCurrentDate(dayjs().format("YYYY.MM.DD HH:mm:ss"));
      }, 1000);
      return () => clearInterval(interval);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-full w-[calc(100%-50px)] animate-spin bg-gradient-to-r from-[#90D5FF] to-[#38A7FF] animate-duration-[5000ms] animate-infinite" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== year) {
    t4 = year !== null && <p className="mb-12 rounded-xsmall bg-O-400 px-6 py-2 font-600 text-Gray-white typo-caption1">{year}년차</p>;
    $[3] = year;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="pb-4 font-800 text-Gray-900 typo-h5">탐나는 제주패스</p>;
    t6 = <p className="font-400 text-Gray-700 typo-body4">기부확인증</p>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4) {
    t7 = <div className="flex flex-col items-center">{t4}{t5}{t6}</div>;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Image src="https://cdn.welfarehello.com/static/jeju-certificate.png" alt={"\uD0D0\uB098\uB294 \uC81C\uC8FC\uD328\uC2A4"} width={350} height={214} className="my-25 h-107 w-175" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== name) {
    t9 = <p className="pb-8 font-800 text-Gray-900 typo-h4">{name}</p>;
    $[10] = name;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="pb-17 font-400 text-Gray-700 typo-body4">제주특별자치도</p>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="font-600 text-Gray-700 typo-caption1">현재시각</span>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== currentDate) {
    t12 = <div className="flex items-center gap-8">{t11}<span className="font-400 text-Gray-600 typo-caption1">{currentDate}</span></div>;
    $[14] = currentDate;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t9) {
    t13 = <div className="flex flex-col items-center">{t9}{t10}{t12}</div>;
    $[16] = t12;
    $[17] = t9;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t7) {
    t14 = <article className="relative h-[25.5rem] w-280 overflow-hidden rounded-large bg-B-100 shadow-lg flex-center">{t3}<div className="absolute left-1 top-1 m-auto flex size-[calc(100%-2px)] flex-col items-center rounded-large bg-Gray-25 pt-40">{t7}{t8}{t13}</div></article>;
    $[19] = t13;
    $[20] = t7;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
};
function _temp() {
  return dayjs().format("YYYY.MM.DD HH:mm:ss");
}